import { useCallback } from "react";

import {
  guestOrderActions,
  selectGuestOrder,
} from "../../store/guestOrder/slice";

import { useAppDispatch, useAppSelector } from "../../store/root/hooks";
import {
  GuestOrderPayload,
  type GuestOrderServiceOperators,
} from "../../types/guestOrder";

const useGuestOrderService = (): Readonly<GuestOrderServiceOperators> => {
  const dispatch = useAppDispatch();

  return {
    guestOrder: useAppSelector(selectGuestOrder),

    submitGuestOrder: useCallback(
      (payload: GuestOrderPayload) => {
        // Dispatch the start action to indicate that the API request is starting
        dispatch(guestOrderActions.submitGuestOrderStart(payload));

        try {
          // Assuming the API call is successful and returns a response
          dispatch(guestOrderActions.submitGuestOrderSuccess(payload));
        } catch (error) {
          dispatch(
            guestOrderActions.submitGuestOrderFailure("Something went wrong")
          );
        }
      },
      [dispatch]
    )
  };
};

export default useGuestOrderService;
